import React from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

interface PartnerLogo {
  img: string;
  alt: string;
}

interface PartnerLogoStripProps {
  logos: PartnerLogo[];
  title?: string;
}

function PartnerLogoStrip({ logos }: PartnerLogoStripProps) {
  return (
    <Box>
      <Box
        sx={{
          py: { xs: 2, md: 2.5 },
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(3, minmax(0, 1fr))',
          },
          gap: 2,
          alignItems: 'stretch',
        }}
      >
        {logos.map((logo) => (
          <Paper
            key={logo.img}
            elevation={0}
            sx={{
              minHeight: 104,
              p: { xs: 2, md: 2.5 },
              borderRadius: 3,
              border: 1,
              borderColor: 'divider',
              bgcolor: 'background.paper',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease',
              '&:hover': {
                borderColor: '#5ABBE5',
                boxShadow: '0 8px 22px rgba(15, 23, 42, 0.08)',
                transform: 'translateY(-1px)',
              },
            }}
          >
            <Box
              component="img"
              src={logo.img}
              alt={logo.alt}
              sx={{
                display: 'block',
                maxWidth: '100%',
                maxHeight: 62,
                objectFit: 'contain',
              }}
            />
          </Paper>
        ))}
      </Box>
    </Box>
  );
}

export default PartnerLogoStrip;
